import { useCallback, useContext, useState } from 'react';
import pluralize from 'pluralize';
import DashboardContext from '@layouts/DashboardLayout/DashboardContext';
import { getUrl, IDENTIFIERS } from '@helpers/urlsHelper';
import Buttons from '@components/Buttons';
import * as tsClient from '@tsClient';
import useNoodleApi from '@hooks/useNoodleApi';
import classes from '../UserWorkflowInfo.module.scss';
import DocumentsListViewModal from './DocumentsListViewModal';

type Props = {
  compiledDocuments: Parameters<typeof DocumentsListViewModal>[0]['compiledDocuments'];
  userWorkflowId: string;
  hasGeneratedPdfs: boolean;
};

const DocumentsAction: React.FC<Props> = ({ compiledDocuments, hasGeneratedPdfs, userWorkflowId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isGeneratingPdfs, setIsGeneratingPdfs] = useState(false);
  const { getData: generateUserWorkflowPdfs } = useNoodleApi(tsClient.workflows.generateUserWorkflowPdfs, { toastOnError: true });

  const { isInDashboard } = useContext(DashboardContext);
  const canEdit = isInDashboard;

  const documentsHref = canEdit ? getUrl(IDENTIFIERS.DASHBOARD_USER_WORKFLOW_DOCUMENTS, { userWorkflowId }) : '#';

  const handleClick = (): void => {
    if (!canEdit) {
      setIsModalOpen(true);
    }
  };

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const handleGeneratePdfs = async (): Promise<void> => {
    setIsGeneratingPdfs(true);
    await generateUserWorkflowPdfs({ userWorkflowId });
    setIsGeneratingPdfs(false);
  };

  return (
    <>
      <div className={classes.workflowExtraInfo_text}>
        <p className={classes['workflow-name']}>Documents</p>
        <div className={classes.workflowExtraInfo_documentsActions}>
          {compiledDocuments.length !== 0 && (
            <a className="caption-bold" onClick={handleClick} href={documentsHref}>
              {pluralize('file', compiledDocuments.length, true)}
            </a>
          )}
          {hasGeneratedPdfs && (
            <>
              {compiledDocuments.length !== 0 && <>·</>}
              <Buttons isWrapper isFetching={isGeneratingPdfs} onClick={handleGeneratePdfs} className={classes.workflowExtraInfo_generateButton}>
                Generate PDFs
              </Buttons>
            </>
          )}
        </div>
      </div>
      {isModalOpen && !canEdit && <DocumentsListViewModal compiledDocuments={compiledDocuments} onClose={handleCloseModal} />}
    </>
  );
};

export default DocumentsAction;
